import { render } from "./FileManager.vue?vue&type=template&id=3a034ba8&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=ts"
export * from "./FileManager.vue?vue&type=script&lang=ts"

import "./FileManager.vue?vue&type=style&index=0&id=3a034ba8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3a034ba8"

export default script